import { FC, useState } from 'react';
import { helpers } from '@/services';
import { useGetCurrentUser } from '@/custom-hooks';

const VISIBLE_COUNT = 3;

type propsType = {
};

export const UserAssignmentsMeetings: FC<propsType> = ({  }) => {
    const [expanded, setExpanded] = useState(false);
    const user = useGetCurrentUser();

    const filteredMeetings = user.meetingsWithAssignments
     .filter(m => m.sections.some(s => s.segments.some(se => se.assignments.some(a => a.user?.id === user.id))))
     .sort((m1, m2) => new Date(m2.date).getTime() - new Date(m1.date).getTime());
    //
    const hasMore = filteredMeetings.length > VISIBLE_COUNT;
    const visibleMeetings = expanded ? filteredMeetings : filteredMeetings.slice(0, VISIBLE_COUNT);

    return (
        <div className={'my-2'}>
            <h3 className={'mb-3'}>
                Asignaciones de las Reuniones:
            </h3>
            {!!visibleMeetings.length ?
                <>
                {visibleMeetings.map(m =>
                    <div key={m.id} className={'mb-3'}>
                        <span className={'fw-bolder me-1'}>
                            {helpers.GetDayOfWeekFromDateString(m.date)} {m.date}
                        </span>
                        {m.sections.filter(s => s.segments.some(se => se.assignments.some(a => a.user?.id === user.id))).map(s =>
                            <span key={s.title}>
                                <div className={'me-2'}>
                                    {s.title}
                                </div>
                                {s.segments.filter(se => se.assignments.some(a => a.user?.id === user.id)).map(se =>
                                    <span key={se.subtitle}>
                                        <div className={'me-1'}>
                                            {se.subtitle}
                                        </div>
                                        {se.descriptions?.map((d, i) =>
                                            <div key={i}>
                                                {d}
                                            </div>
                                        )}
                                        {se.assignments.filter(a => a.user?.id === user.id).map(a =>
                                            <span key={a.room + a.isHelper}>
                                                {a.user!.id === user.id ?
                                                    <span>
                                                        {a.room ? 'Auditorio' : 'Sala Auxiliar'} {a.isHelper ? '(Ayudante)' : ''}
                                                    </span>
                                                    :
                                                    <span>
                                                        con {a.user!.name} {a.user!.lastName} {a.isHelper ? 'de ayudante' : ''}
                                                    </span>
                                                }
                                            </span>
                                        )}
                                    </span>
                                )}
                            </span>
                        )}
                    </div>
                )}
                {hasMore &&
                    <button className={'btn btn-link p-0 mt-1 text-decoration-none'}
                        onClick={() => setExpanded(x => !x)}
                    >
                        {expanded ?
                            <>Ver menos</>
                            :
                            <>Ver {filteredMeetings.length - VISIBLE_COUNT} más</>
                        }
                    </button>
                }
                </>
                :
                <h4>
                    Ninguna
                </h4>
            }
        </div>
    );
}
